import * as yup from 'yup'

export const validationSchema = yup.object({
  status: yup.string().required('Field is required'),

  clientId: yup.string().required('Field is required'),

  workHours: yup
    .number()
    .required('Field is required')
    .moreThan(0, 'Must be greater than 0'),

  totalPrice: yup.number().required('Field is required'),

  // paymentDue: yup.number().required('Field is required'),
})
